enum TableEndpoints {
  GetMarginAndDrawdown = "/api/sumTable/getMarginAndDrawdown",
  GetIncome = "/api/sumTable/getIncome",
  GetTodayTable = "/api/sumTable/getTodayTable",
}

export default TableEndpoints;
